import React from 'react';
import DetailsClearance from './DetailsClearance';
import { showState } from '../../../../selectors/events/timetable';

const StatesDetails = ({ clearing = {} }) => {
    const live = clearing.live;
    const nonLinear = clearing.nonLinear;
    if (showState(live) || showState(nonLinear)) {
        return (
            <React.Fragment>
                <div className="ckp-entry-details-clearance">
                    <DetailsClearance live={live} nonLinear={nonLinear} useUntil={clearing.useUntil} />
                    {clearing.comments ? (
                        <div className="ckp-entry-details-comments is-live">
                            <p className="ckp-entry-details-label">Comments</p>
                            <div className="ckp-entry-details-field">
                                {(clearing.comments || 'No comments').split(/\n/).map((x, i) => (
                                    <p key={i} dangerouslySetInnerHTML={{ __html: x || '&nbsp;' }} />
                                ))}
                            </div>
                        </div>
                    ) : null}
                </div>
                <span className="ckp-modal-full-line is-sub" />
            </React.Fragment>
        );
    } else {
        return null;
    }
};

export default StatesDetails;



// WEBPACK FOOTER //
// ./src/components/application/timetable/entries/StatesDetails.js